module.exports = __webpack_public_path__ + "static/media/student17.03a68f44.png";